import {Employee} from '../employees';
import {observable} from 'mobx';

class NmbrDirectoryEmployee extends Employee {
  @observable errorsFromLastSync = {};
}

export default NmbrDirectoryEmployee;
